import { cloneDeep } from 'lodash';
import wujiFetch from '@/utils/wujiFetch';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';
;
// 编辑态下每个 CRenderer 创建时都会拉一次全局常量(见 UICoreXiaoyaoPlugin.patchCRenderer),
// 列表类组件按行渲染会把它放大成几十上百次请求, 因此这里做缓存与并发合并
const LIST_CACHE_TTL = 10 * 1000;
class GlobalConstantService {
    listCache = new Map();
    async create(projectId, req) {
        const url = `${getXyManagePathPrefix()}/global-constant?projectid=${projectId}`;
        try {
            return await wujiFetch(url, {
                method: 'POST',
                body: JSON.stringify(req),
            });
        }
        finally {
            this.clearListCache();
        }
    }
    async update(projectId, constantId, req) {
        const url = `${getXyManagePathPrefix()}/global-constant/${constantId}?projectid=${projectId}`;
        try {
            return await wujiFetch(url, {
                method: 'PATCH',
                body: JSON.stringify(req),
            });
        }
        finally {
            this.clearListCache();
        }
    }
    async delete(projectId, globalConstantId) {
        const url = `${getXyManagePathPrefix()}/global-constant/${globalConstantId}?projectid=${projectId}`;
        try {
            return await wujiFetch(url, {
                method: 'DELETE',
            });
        }
        finally {
            this.clearListCache();
        }
    }
    async list(projectId, options = {}) {
        const url = `${getXyManagePathPrefix()}/global-constant?projectid=${projectId}&size=total&sort=ctime&order=desc`;
        const cached = this.listCache.get(url);
        let entry = cached;
        if (options.noCache || !cached || Date.now() - cached.time >= LIST_CACHE_TTL) {
            entry = { time: Date.now(), request: wujiFetch(url) };
            this.listCache.set(url, entry);
            // 失败的请求不能留在缓存里, 否则后续调用会一直复用同一个 rejected promise
            entry.request.catch(() => {
                if (this.listCache.get(url) === entry)
                    this.listCache.delete(url);
            });
        }
        // 调用方(如全局常量管理页)会就地改写返回结果, 每次调用都要拿到独立副本
        return cloneDeep(await entry.request);
    }
    clearListCache() {
        this.listCache.clear();
    }
}
export const globalConstantService = new GlobalConstantService();
